export const ADD_TO_CART = "cart/addToCart";
export const DELETE_CART = "cart/deleteCart";
export const INCREMENT_QUANTITY = "cart/incrementQuantity";
export const DECREMENT_QUANTITY = "cart/decrementQuantity";
